import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import { useUtils } from "@/app/hooks/useUtils";
import { MdOutlineDone } from "react-icons/md";
import { useRouter } from "@/app/hooks/useRouter";
import { useEffect } from "react";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useMedicalHistoryDetailsAPI } from "@/app/hooks/api_hooks/Membership/useMedicalHistoryDetailsAPI";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import { useLoader } from "@/app/hooks/useLoader";
import { Disclosure } from "@headlessui/react";

interface MedicinetabProps {
  isDefaultShow?: boolean;
  emrDetails?: any;
}

const MedicineHistoryTab = ({ isDefaultShow = false, emrDetails }: MedicinetabProps) => {
  const { NO_APPOINTMENTS } = useImageConstants();
  const { veticDateFormat } = useUtils();
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerId } = routeState.state as ICustomerProfileState;

  const { execute: fetchMedicalHistory, medicalHistory } = useMedicalHistoryDetailsAPI();

  useEffect(() => {
    if (customerId) {
      fetchMedicalHistory(customerId);
    }
  }, [customerId]);

  useEffect(() => {
    const customerId = emrDetails?.customer_details?.customer_id;
    if (customerId) {
      fetchMedicalHistory(customerId);
    }
  }, [emrDetails]);

  const isVaccinationLoader = useLoader("isMedicalHistoryListInprogress");
  const isPurchasedRenderComponent = (is_purchased: boolean) => {
    return (
      <div className="flex items-start space-x-2">
        <span
          className={`mt-1 flex items-center justify-center w-4 h-4 rounded-full border 
            ${is_purchased ? "border-green-400 bg-green-50" : "border-red-400 bg-red-50"}`}
        >
          {is_purchased ? (
            <MdOutlineDone className="w-3 h-3 text-green-600" />
          ) : (
            <XMarkIcon className="w-3 h-3 text-red-500" />
          )}
        </span>
      </div>
    );
  };

  return (
    <>
      {" "}
      <div className="py-2 md:py-2 lg:py-4">
        <div className=" border rounded-lg bg-white">
          <Disclosure defaultOpen={isDefaultShow}>
            {({ open }) => (
              <>
                <Disclosure.Button className=" px-2 md:px-2 lg:px-2  py-2 md:py-3 items-center flex w-full justify-between rounded-lg bg-[#808DA01A] text-left text-theme-sm font-medium  focus:outline-none ">
                  <div className="flex flex-row gap-16 items-center">
                    <div className="flex flex-col gap-1">
                      <span className="text-theme-sm text-[#000]">Medicine History</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-theme-xs  underline ">
                    {open ? "Hide Details" : "Show Details"}
                    <ChevronDownIcon className={`${open ? "rotate-180 transform" : ""} h-4 w-4 `} />
                  </div>
                </Disclosure.Button>
                <Disclosure.Panel className=" px-2 py-2 bg-white ">
                  <div className="bg-white w-[100%]">
                    {isVaccinationLoader ? (
                      <TableSkeletonComponent columnLength={6} bodyLength={5} />
                    ) : (
                      <div className="w-full max-h-[500px] md:max-h-[600px] overflow-auto bg-white rounded-xl">
                        {medicalHistory?.length > 0 ? (
                          <div className="w-full max-h-[500px] md:max-h-[600px] overflow-auto bg-white rounded-xl">
                            <table className="w-full min-w-[640px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                              <thead className="sticky top-0 z-10 bg-[#F5F5F5] text-[#1F1F23] font-normal">
                                <tr>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23]"
                                    scope="col"
                                  >
                                    Date
                                  </th>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23] "
                                    scope="col"
                                  >
                                    Doctor
                                  </th>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23] "
                                    scope="col"
                                  >
                                    Medicine & History
                                  </th>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23] "
                                    scope="col"
                                  ></th>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23] "
                                    scope="col"
                                  >
                                    
                                  </th>
                                  <th
                                    className="px-3 py-3 text-left whitespace-nowrap text-[10px] sm:text-xs font-medium text-[#1F1F23] "
                                    scope="col"
                                  >
                                    Invoice
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="overflow-hidden rounded-xl w-full">
                                {medicalHistory?.map((item, index) => {
                                  return (
                                    <tr key={index} className="bg-white transition">
                                      <td className="whitespace-nowrap px-2 md:px-3 lg:px-4 py-3 text-theme-xs  text-black ">
                                        {veticDateFormat(item?.date) || "--"}
                                      </td>
                                      <td className="whitespace-nowrap px-2 md:px-3 lg:px-4 py-3 text-theme-xs text-black">
                                        {item?.emrs?.length > 0 ? (
                                          <div className="flex flex-col gap-1">
                                            {item?.emrs?.map((emr, idx: any) => {
                                              return (
                                                <>
                                                  <p>{emr?.staff_name}</p>
                                                  <p className="text-[#6B7280] text-theme-xs">{emr?.clinic_name}</p>
                                                  <p
                                                    className={`text-[#0068FF] font-medium underline text-theme-xs cursor-pointer ${item?.emr?.length !== idx && "pb-3"}`}
                                                    onClick={() => emr?.filename && window.open(emr?.pdf_url, "_blank")}
                                                  >
                                                    {emr?.filename || "NA"}
                                                  </p>
                                                </>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          "NA"
                                        )}
                                      </td>
                                      <td className="px-2 md:px-3 lg:px-4 py-3 text-theme-xs text-black w-[34rem]">
                                        <div className="flex flex-col gap-2 break-words">
                                          {item?.medicines?.length > 0 && <p className="font-medium">Medicine</p>}
                                          {item?.medicines?.map((medicine, index) => (
                                            <div
                                              key={index}
                                              className="flex flex-wrap items-center gap-1"
                                            >
                                              <p className="flex  gap-2 ">
                                                {isPurchasedRenderComponent(medicine?.is_purchased)}
                                                <p className="inline-flex items-center gap-1 text-theme-xs text-gray-800 ">
                                                  {medicine?.name} &nbsp;&nbsp; x &nbsp;&nbsp;{medicine?.quantity}
                                                </p>
                                              </p>
                                            </div>
                                          ))}
                                          {(item?.lab_tests?.length > 0 || item?.recommended_lab_tests?.length > 0) && (
                                            <p className="font-medium pt-3 pb-1">Lab Test (include recommended)</p>
                                          )}

                                          {item?.lab_tests?.map((lab, index) => (
                                            <div
                                              key={index}
                                              className="flex flex-wrap items-center gap-1 whitespace-normal break-words"
                                            >
                                              <p className="flex  gap-2 ">
                                                {isPurchasedRenderComponent(lab?.is_purchased)}

                                                <p className="inline-flex items-center gap-1 text-theme-xs text-gray-800 ">
                                                  {lab?.name} &nbsp;&nbsp; x &nbsp;&nbsp;{lab?.quantity}
                                                </p>
                                              </p>
                                            </div>
                                          ))}
                                          {item?.recommended_lab_tests?.map((recommended_test, index) => (
                                            <div
                                              key={index}
                                              className="flex flex-wrap items-center gap-1 whitespace-normal break-words"
                                            >
                                              <p className="flex  gap-2 ">
                                                {isPurchasedRenderComponent(recommended_test?.is_purchased)}

                                                <p className="inline-flex items-center gap-1 text-theme-xs text-gray-800 ">
                                                  {recommended_test?.name}&nbsp;&nbsp; x &nbsp;&nbsp;
                                                  {recommended_test?.quantity}
                                                </p>
                                              </p>
                                            </div>
                                          ))}
                                          {item?.treatment?.length > 0 && (
                                            <p className="font-medium pt-2">Treatment</p>
                                          )}
                                          {item?.treatment?.map((treatment, index) => (
                                            <div
                                              key={index}
                                              className="flex flex-wrap items-center gap-1 whitespace-normal break-words"
                                            >
                                              <p className="flex  gap-2">
                                                {isPurchasedRenderComponent(treatment?.is_purchased)}

                                                <p className="inline-flex items-center gap-1 text-theme-xs text-gray-800 ">
                                                  {treatment?.name}&nbsp;&nbsp; x &nbsp;&nbsp;{treatment?.quantity}
                                                </p>
                                              </p>
                                            </div>
                                          ))}
                                        </div>
                                      </td>
                                      <td className="whitespace-nowrap px-2 md:px-3 lg:px-4 py-3 text-theme-xs text-black"></td>
                                      <td className="whitespace-nowrap px-2 md:px-3 lg:px-4 py-3 text-theme-xs text-black"></td>
                                      <td className="whitespace-nowrap px-2 md:px-3 lg:px-4 py-3 text-theme-xs ">
                                        {item?.invoices?.length > 0 ? (
                                          <>
                                            {" "}
                                            {item?.invoices?.map((inv, inv_index: any) => {
                                              return (
                                                <div
                                                  onClick={() => inv?.pdf_url && window.open(inv?.pdf_url, "_blank")}
                                                  className={`${item?.invoice?.length !== inv_index && "pb-2"} text-[#0068FF]`}
                                                >
                                                  <span className="cursor-pointer">{inv?.filename || "NA"}</span>
                                                </div>
                                              );
                                            })}
                                          </>
                                        ) : (
                                          "NA"
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <NoDataFoundComponent
                            imageURL={NO_APPOINTMENTS}
                            message="No Medicine History Found."
                            description="No Medicine details are available for the selected customer."
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </>
  );
};

export default MedicineHistoryTab;
